import { DEFAULT_AVATAR_FILENAME } from './constants/avatars';

/**
 * Converts a snake_case activity name to Title Case for display.
 * e.g. "bike_terrain" → "Bike Terrain"
 */
export const formatActivityName = (name) =>
    name ? name.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : name;

export { DEFAULT_AVATAR_FILENAME };

/**
 * Fetch an avatar's raw SVG markup from the public avatars folder.
 * @param {string} filename A stable avatar filename, e.g. "potato_avatar_1.svg".
 * @returns {Promise<string>} The SVG content as text.
 */
export const fetchAvatarSvg = async (filename) => {
    const response = await fetch(`/avatars/${filename}`);
    return response.text();
};

/**
 * Fetch the default starter avatar's raw SVG markup.
 * Used as a fallback when a user has no avatar or their avatar fails to load.
 * @returns {Promise<string>} The SVG content as text.
 */
export const fetchDefaultAvatarSvg = async () => fetchAvatarSvg(DEFAULT_AVATAR_FILENAME);
